<template>
  <div
    :class="
      `seasidetms_header_search_form${searchMobile ? ' seasidetms_show' : ''}`
    "
    data-note="mobile"
  >
    <span
      class="seasidetms_header_search_form_close seasidetms_theme_icon_cancel"
      @click.stop.prevent="onClose"
    ></span>
    <div class="search_bar_wrap">
      <form>
        <p class="search_field">
          <input
            name="s"
            class="searchbar__autocomplete_mobile-input"
            :placeholder="$t('searchProduct')"
            @input="update"
            @focus="show"
            type="search"
            v-model="query"
            autofocus
            autocomplete="off"
          />
        </p>
        <p class="search_button">
          <span class="seasidetms-icon-search search_button-icon"></span>
        </p>
        <ul
          class="searchbar__autocomplete_mobile"
          v-show="isActive && items.length"
        >
          <li
            class="searchbar__autocomplete_mobile-item"
            v-for="product in items"
            :key="product._id"
          >
            <router-link
              class="searchbar__autocomplete_mobile-item-image"
              :to="routeTo(product)"
              @click.native="onRouteClick"
            >
              <img
                :src="getProductImgSrc(product)"
                :alt="getProductName(product)"
              />
            </router-link>
            <router-link
              class="searchbar__autocomplete_mobile-link"
              :to="routeTo(product)"
              @click.native="onRouteClick"
            >
              <span class="searchbar__autocomplete_mobile-name">
                {{ getProductName(product) }}
              </span>
            </router-link>
            <div class="searchbar__autocomplete_mobile-item-price">
              <div class="searchbar__autocomplete_mobile-item-old_price">
                {{ $h.formatPrice(product.price) }} грн
              </div>
              <div class="searchbar__autocomplete_mobile-item-new_price">
                {{ $h.formatPrice(product.newPrice) }} грн
              </div>
            </div>
          </li>
        </ul>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { setTimeout, clearTimeout } from 'timers'

export default {
  name: 'SearchBarFlyMobile',
  data() {
    return {
      query: '',
      oldQuery: '',
      items: [],
      timer: null,
      isActive: false,
      minChars: 3,
      updatedTime: 300,
      lang: '',
    }
  },
  computed: {
    queryStr() {
      return this.query.trim()
    },
    ...mapState(['searchMobile']),
  },
  watch: {
    searchMobile(newValue) {
      if (newValue) {
        const input = document.querySelector('[autofocus]')
        if (input) {
          setTimeout(() => {
            input.focus()
          }, 10)
        }
      }
    },
  },
  methods: {
    ...mapMutations(['setSearchMobile']),
    getProductImgSrc(product) {
      return Array.isArray(product.img) && this.product.img.length
        ? `/img${product.img[0]}`
        : product.img
        ? `/img${product.img}`
        : '/img/uploads/error.png'
    },
    onClose() {
      this.setSearchMobile(false)
      this.hide()
      this.reset()
    },
    ...mapActions(['fetchFlySearch']),
    renderItems(response) {
      this.items = response
      if (this.items.length) {
        this.isActive = true
      }
    },
    onRouteClick() {
      this.onClose()
    },
    getProductName(product) {
      return this.lang === 'ru' ? product.name_ru : product.name_ua
    },
    routeTo(product) {
      return this.lang
        ? `/${this.lang}/product/${this.categoryPath(product)}/${product.slug}`
        : `/product/${this.categoryPath(product)}/${product.slug}`
    },
    categoryPath(product) {
      const cc = `${product.childCategory}`
      let refPath = `${product.parentCategory}/${cc.replace(',', '/')}`
      let path = ''
      let chain = refPath.split('/')
      let _c = this.$store.state.categories
      chain.forEach(p => {
        if (!_c) return
        let c = _c.find(c => c.id === p)
        if (c) {
          _c = c.children || null
          if (path !== '') path += '/'
          path += c.slug
        }
      })
      return path
    },
    fetch() {
      this.fetchFlySearch(this.queryStr).then(this.renderItems)
    },
    update() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (!this.query) {
        this.reset()
      }
      if (this.queryStr.length < this.minChars) {
        this.hide()
      } else {
        if (this.oldQuery !== this.query) {
          this.timer = setTimeout(this.fetch, this.updatedTime)
        } else {
          this.isActive = true
        }
      }
    },
    reset() {
      this.items = []
      this.query = ''
    },
    hide() {
      this.isActive = false
      this.oldQuery = this.query
    },
    show() {
      if (this.queryStr.length >= this.minChars) {
        this.isActive = true
      }
    },
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
.searchbar__autocomplete_mobile {
  margin: 2px 0 0 0;
  padding: 15px 0 0 0;
  list-style: none;
  overflow: auto;
  max-height: calc(100vh - 105px - 7%);
  border-bottom: 3px solid rgba(255, 67, 0, 0.95);
  border-radius: 0;
  background: rgba(255, 255, 255, 0.95);
}
.searchbar__autocomplete_mobile-item {
  list-style: none;
  margin: 0;
  padding: 15px;
  display: flex;
  justify-content: space-between;
}
.searchbar__autocomplete_mobile-item:before {
  display: none;
}
.searchbar__autocomplete_mobile-link {
  display: block;
  padding: 5px 15px;
}
.searchbar__autocomplete_mobile-item-image {
  display: flex;
  width: 60px;
  height: 60px;
  overflow: hidden;
  margin-right: 10px;
  flex-shrink: 0;
}
.searchbar__autocomplete_mobile-item-image img {
  width: 100%;
  object-fit: cover;
}
.searchbar__autocomplete_mobile-link {
  font-size: 16px;
  flex-grow: 1;
  line-height: 1.2;
}
.searchbar__autocomplete_mobile-item-price {
  font-size: 15px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
}
.searchbar__autocomplete_mobile-item-price div {
  text-align: right;
  line-height: 1;
  white-space: nowrap;
}
.searchbar__autocomplete_mobile-item-old_price {
  font-size: 10px;
  color: #555;
  text-decoration: line-through;
}
.searchbar__autocomplete_mobile-item-new_price {
  font-weight: 700;
  margin-top: 5px;
}
.searchbar__autocomplete_mobile-input {
  color: #fff!important;
}
</style>
